/**
 * Format a number as currency (EUR)
 */
export function formatCurrency(amount: number, currency: string = 'EUR'): string {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

/**
 * Format a number as compact currency (e.g., €1.2K, €3.5M)
 */
export function formatCurrencyCompact(amount: number, currency: string = 'EUR'): string {
  if (amount >= 1_000_000) {
    return `€${(amount / 1_000_000).toFixed(1)}M`
  }
  if (amount >= 1_000) {
    return `€${(amount / 1_000).toFixed(1)}K`
  }
  return formatCurrency(amount, currency)
}
